import React from 'react';
import AdminLayout from '../components/AdminLayout';
import GiftManagementSection from '../components/GiftManagementSection';
import '../styles/AdminPages.css';

const GiftManagement: React.FC = () => {
  return (
    <AdminLayout>
      <GiftManagementSection />
    </AdminLayout>
  );
};

export default GiftManagement;

